module.exports = __webpack_public_path__ + "media/images/vector-14@2x-8f4770abe9321eea9d5a9a171c5e4925.png";